import type { Carrier } from '../carrier/carrier.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class CarrierFactory extends ObjectFactory<Carrier> {
  protected getDefaults(): Carrier {
    return {
      ...baseDocumentFactory.build(),
      code: 'DHL',
      enabledScopes: [],
      integration: false,
      name: 'DHL Express',
    };
  }
}

export const carrierFactory = new CarrierFactory();
